import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HomeHero from "@/pages/home/components/HomeHero";
import HomeFeatures from "@/pages/home/components/HomeFeatures";
import HomeCategories from "@/pages/home/components/HomeCategories";
import HomeStats from "@/pages/home/components/HomeStats";
import HomeHotArticles from "@/pages/home/components/HomeHotArticles";
import HomeFAQ from "@/pages/home/components/HomeFAQ";
import HomeCTA from "@/pages/home/components/HomeCTA";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HomeHero />
        <HomeStats />
        <HomeFeatures />
        <HomeCategories />
        <HomeHotArticles />
        <HomeFAQ />
        <HomeCTA />
      </main>
      <Footer />
    </>
  );
}